<template>
    <div class="col-lg-12">
        <div class="card border-top-0">
            <div class="card-body personal-info">
                <form @submit.prevent="submitForm">
                    <div class="mb-4 d-flex align-items-center justify-content-between">
                        <h5 class="fw-bold mb-0 me-4">
                            <span class="d-block mb-2">İlaç Deposu Kartı:</span>
                            <span class="fs-12 fw-normal text-muted text-truncate-1-line">İlaç Deposu kartlarını
                                buradan düzenleyebilirsiniz.</span>
                        </h5>
                        <div class="d-flex gap-2">
                            <button type="submit" class="btn btn-lg btn-light-brand bg-green text-white">Kaydet</button>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Depo Adı: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="warehouse.name" placeholder="Depo Adı">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Depo Konumu: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="warehouse.location"
                                    placeholder="Depo Konumu">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Açıklama: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="warehouse.description"
                                    placeholder="Açıklama">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Varsayılan Depo: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="form-check form-switch form-switch-lg">
                                <input class="form-check-input c-pointer" type="checkbox"
                                    :checked="warehouse.default ? true : false" v-model="warehouse.default">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Aktif Depo: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="form-check form-switch form-switch-lg">
                                <input class="form-check-input c-pointer" type="checkbox"
                                    :checked="warehouse.active ? true : false" v-model="warehouse.active">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
    name: 'EditWarehouse',
    data() {
        return {
            warehouse: {},
        }
    },
    async mounted() {
        const warehouseId = this.$route.params.id;
        console.log(warehouseId);
        if (warehouseId) {
            await this.fetchWarehouse(warehouseId);
        }
    },
    methods: {
        async fetchWarehouse(id) {
            try {
                const response = await this.$axios.get(`warehouse/${id}/`);
                this.warehouse = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async submitForm() {
            try {
                const response = await this.$axios.put(`warehouse/${this.warehouse.id}/`, this.warehouse);
                Swal.fire('Başarılı', 'İlaç deposu başarıyla güncellendi.', 'success');
                console.log(response);
                this.$router.push({ name: 'Warehousess', params: { page: 1 } });

            } catch (error) {
                Swal.fire('Hata', error, 'error');
                console.log(error);
            }
        }
    }
}
</script>